import {SuperBit_swaggerClient} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class LoginModel {
    client:any;
    constructor() {
        const apiUrl = localStorage.getItem('apiUrl');
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
        //this.client = new SuperBit_swaggerClient("https://localhost:44333");
    }

    isAuthTokenSaved = (): boolean => {
        const token = localStorage.getItem('AuthToken');
        return token ? true : false
    }
    async userGetRoles (): Promise<any>  {
        return await this.client.userGetRoles({});
    }
    async loginUser (loginData: any): Promise<any> {
        return await this.client.userLogin(loginData);
    }

    async logOut (clearAll: boolean = false) {
        this.client.userLogout();
        console.log('logOut');
        localStorage.removeItem('AuthToken');
        const emailSettingsStr = localStorage.getItem('emailSettings');
        try {
            if (emailSettingsStr) {
                const emailSettings = JSON.parse(emailSettingsStr);
                emailSettings.emails.forEach(async (emailAccount: any) => {
                    localStorage.removeItem(`emailAccount_${emailAccount.id}`);
                });
            }
            
        } catch (error) {
            
        }
        if (clearAll) {
            sessionStorage.clear();
            localStorage.clear();
        }
    }

    async clearSavedUserData() {
        const keys: string[] = [
            'lastClientsFilter',
            'leadsAdvancedSearchOptions',
            'lastLeadsFilter'
        ];

        keys.forEach((key: string) => {
            localStorage.removeItem(`${key}`);
        })


    }

    async Break () {
        this.client.userBreak();
        localStorage.setItem('break', 'true');
    }

    async BreakEnd () {
        this.client.userBreakEnd();
        localStorage.setItem('break', 'false');
    }

    async userSendOTPCode(obj: any): Promise<any> {
        return await this.client.userSendOTPCode(obj);
    }

    async userCheckOTPCode(obj: any): Promise<any> {
        return await this.client.userCheckOTPCode(obj);
    }

}